import React, { useState,useEffect } from "react";
import Logo from "./assets/img/logo.png";
import { FaInfoCircle } from "react-icons/fa";
import { LuMenu } from "react-icons/lu";
import { FaSignOutAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import aviator from "../assets/aviator.png";
import aviator1 from "../assets/rule1.png";
import aviator2 from "../assets/rule2.png";
import aviator3 from "../assets/rule3.png";
import axios from 'axios'
function Header({ profileData }) {

  const [showModal, setShowModal] = useState(false);
  const [listHowtoplays, setlistHowtoplays] = useState(null);
  const toggleModal = () => {
    setShowModal((prev) => {
     
      return !prev;
    });
  };
  useEffect (()=>{
    HandlerlistHowtoplays();
  },[])
  const handleLogout = () => {
    const isConfirmed = window.confirm("Are you sure you want to log out?");

    if (isConfirmed) {
      // Clear localStorage
      localStorage.clear(); // Clears all data from localStorage
    

      window.location.href = "/";
    } else {
     
    }
  };
  const HandlerlistHowtoplays = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    const role = localStorage.getItem("role");
    try {
      const response = await axios.post('https://aviatornode.a2logicgroup.com/api/bets/listHowtoplays',
        { userId, role },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.warn("response.data", response.data.data.howtoplays)
      setlistHowtoplays(response.data.data[0]);
    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };
  return (
    <div id="header">
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <div className="logo">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="howtoplay">
            <button className="gap-1" onClick={toggleModal}>
              <FaInfoCircle />
              <span>How To Play</span>
            </button>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2 m-0">
          <div className="amount">
            <h3 className="d-flex align-items-center gap-2 m-0">
              {profileData.toFixed(2)} <span>INR</span>
            </h3>
          </div>
          <div className="amount">
            <h2
              className="d-flex align-items-center gap-2 m-0 text-light"
              onClick={handleLogout}
              style={{ cursor: "pointer" }}
            >
              <FaSignOutAlt />
            </h2>
          </div>
          <div className="text-color"> |</div>
          <div className="menuprofile">
            <LuMenu />
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="custom-modal">
            <div className="modal-content hows_play">
              <h3 className="modal-title">
                <span>Game Rules</span>
                <button
                  className="close-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleModal();
                  }}
                >
                  <div className="result history">
                    <IoClose className="arrowDown" />
                  </div>
                </button>
              </h3>
              <div className="gameRule">
                <p className="">
                  {listHowtoplays && listHowtoplays.heading}
                </p>
                <Link to="#"> Read more about provably fair system </Link>
                <h5>HOW TO PLAY</h5>
                <img src={aviator} alt="aviator" />
                <h6> Aviator is as easy to play as 1-2-3: </h6>
                <div className="steps-container row">
                  <div className="step step-1">
                    <h3>01</h3>
                    <img src={aviator1} alt="aviator" />
                    <div className="step-text pt-2">
                      <span className="text-uppercase">Bet</span>
                      BET before take-off
                    </div>
                  </div>
                  <div className="step step-2">
                    <h3>02</h3>
                    <img src={aviator2} alt="aviator" />
                    <div className="step-text">
                      <span className="text-uppercase">WATCH</span>
                      as your Lucky Plane takes off and your winnings increase.
                    </div>
                  </div>
                  <div className="step step-3">
                    <h3>03</h3>
                    <img src={aviator3} alt="aviator" />
                    <div className="step-text">
                      <span className="text-uppercase">Exchange</span>
                      CASHOUT-before the plane disappears and wins X times more!
                    </div>
                  </div>
                </div>
                <p>
                  But remember,if you did not have time to Cash Out before the
                  Lucky Plane flies away,your bet will be lost.Aviator is pure
                  excitement!Risk and win.It's all in your hands!
                </p>

                <div className="rules-list pt-3">
                  <div className="rules-list-title">More details</div>
                  <ul className="list-group">
                    <li className="list-group-item">
                    {listHowtoplays.details}
          
                    </li>
                  
                  </ul>
                </div>
                <h5> GAME FUNCTIONS </h5>
                <div className="rules-list pt-2">
                  <div className="rules-list-title">Bet Cash Out</div>
                  <ul className="list-group">
                    <li className="list-group-item">
                      {listHowtoplays.betCashout}
                    </li>
                
                  </ul>
                </div>

                <div className="rules-list pt-2">
                  <div className="rules-list-title">
                    Auto Play Auto Cash Out
                  </div>
                  <ul className="list-group">
                    <li className="list-group-item">
                        {listHowtoplays.autoPlay}
                    </li>
                   
                  </ul>
                </div>

                <div className="rules-list pt-2">
                  <div className="rules-list-title">Live Bets Statistics</div>
                  <ul className="list-group">
                    <li className="list-group-item">
                    {listHowtoplays.liveBet}
                    </li>
                   
                  </ul>
                </div>

                <div className="rules-list pt-2">
                  <div className="rules-list-title">Randomisation</div>
                  <ul className="list-group">
                    <li className="list-group-item">
                    {listHowtoplays.randomisation}
                   
                      <a href="#">Read more about provably fair system</a>
                    </li>
                    
                  </ul>
                </div>

                <div className="rules-list pt-2">
                  <div className="rules-list-title">Return to Player</div>
                  <ul className="list-group">
                    <li className="list-group-item">
                      {listHowtoplays.returnToPlayer}
                     
                    </li>
                  </ul>
                </div>

                <div className="rules-list pt-2">
                  <div className="rules-list-title">Other</div>
                  <ul className="list-group">
                    <li className="list-group-item">
                    {listHowtoplays.other}
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
